<template>
  <div class="header">
    <div  class="header-logo">
      <div>
        <a href="/" target="" class="l-h-c-c" style="position: relative;height: 85px;">
          <img src="../../../static/image/logo.png" alt="江城百臻" class="hn-logo"
          style="height: 85px;overflow-clip-margin: content-box;overflow: clip;">
        </a>
      </div>
      <div class="search">
        <div class="searchSelect">
          <el-dropdown @command="searchCommand" trigger="click">
                <span class="el-dropdown-link">{{searchObj.searchVal}}
                  <i class="el-icon-arrow-down cur-poi el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                        v-for="item in options"
                        :key="item"
                        :command="item">{{item}}
                    </el-dropdown-item>
                </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="searchRight">
          <input type="text"
            v-model="searchObj.keyword"
            placeholder="请输入您要的商品"
          >
        </div>
        <span class="btn cur-poi" @click="searchPro" style="background-color:#39bf3e;color:white">
          <i class="icon el-icon-search" style="margin-left:10px;font-size:15px">搜索</i>
        </span>
      </div>
      <div class="supply-btn">
        <!-- <el-button type="warning">免费发供应</el-button> -->
      </div>
    </div>
    <div class="nav">
      <nav>
        <ul>
          <li :class="homeSelectIndex == index ? 'selected' : ''" v-for="(item,index) in categoryList.slice(0, 6)" :key="index" @click="jumpCategory(item,index)">
            {{item.classifyName}}
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import {
  getCategory
} from '@/api/nav.js'
// import store from '../../store/index.js'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'homHeader',
  computed: {
    ...mapGetters([
        'searchObj',
        'homeSelectIndex'
    ])
  },
  data () {
    return {
      // options: ['商品', '行业', '行情', '采购'],
      options: ['商品'],
      categoryList: [
        {
            classifyName: '首页',
        },
        {
            classifyName: '行业资讯',
            classifyImage: '',
        },
        {
            classifyName: '采购大厅',
            classifyImage: ''
        },
        {
            classifyName: '供应大厅',
            classifyImage: ''
        },
        {
            classifyName: '行情大厅',
            classifyImage: '',
        },
      ],
    }
  },
  mounted () {
    // this.getCategoryData()
  },
  watch: {
    // 监听store
    '$store.state.searchObj': {
        handler (nVal, oVal) {
        console.log('$store.state.searchObj--nVal---', nVal)
        console.log('$store.state.searchObj--oVal---', oVal)
      }
    }
  },
  methods: {
    ...mapMutations({
      setSearchObj: 'SET_SEARCHOBJ',
      setHomeSelectIndex: 'SET_HOMESELECTINDEX'
    }),
    searchCommand (command) {
      this.setSearchObj({
        searchVal: command
      })
    },
    // 查找
    searchPro () {
      // this.setSearchObj({
      //   keyword: this.searchObj.keyword,
      //   searchVal: this.searchObj.searchVal
      // })
      this.setHomeSelectIndex(3)
      if (this.$route.name !== 'search') {
        this.$router.push({
          path: '/activity/search'
        })
      }
    },
    async getCategoryData () {
      const response = await getCategory()
      const res = response.data
      const homeItem = {
        classifyName: '首页'
      }
      if (res.code === '200') {
        this.categoryList.push(homeItem)
        res.data.forEach(item => {
            this.categoryList.push(item)
        })
        // this.categoryList = res.data
      }
    },
    // 跳转到类别主页
    jumpCategory (item, index) {
        this.setHomeSelectIndex(index)
        // let tabData = ['商品', '行业', '采购', '商品', '行情']
        let tabData = ['商品', '商品', '商品', '商品', '商品']
        this.setSearchObj({
            searchVal: tabData[index],
            keyword: ''
        })
        if (index === 0) {
             this.$router.push({path: '/index'})
             return
        }
        this.$router.push({
            name: 'category',
            query: {
                tabIndex: index,
                classifyData: JSON.stringify(item)
            }
        })
    },
  }
}
</script>

<style scoped lang="scss">
$lightBlack: #666666;
$navSearchHeight: 39px;
.header{
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: column;
//   margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  margin-top: 1px;
  margin-bottom: 15px;
  background-color: #f5f5f5;

  .header-logo{
    display: flex;
    width:100%;
    background: #fff;
    padding-top: 2%;
    padding-left: 10%;
    padding-right: 10%;
    box-sizing: border-box;
    .search{
      width: 50%;
      height: 39px;
      border: 1px solid #39bf3e;
      // float: right;
      margin-top: 20px;
      margin-left: 10%;
      display: flex;
      .searchSelect{
        width: 82px;
        height: 30px;
        margin-top: 2px;
        border-right: 1px solid #39bf3e;
        text-align: center;
        line-height: 30px;
        .el-dropdown{
          color: #CCCCCC;
        }
      }
      .searchRight{
        width: 180px;
        flex: 1;
        input{
          padding-left: 15px;
          width: 360px;
          font-size: 14px;
          color: #333;
          line-height: 35px;
        }
      }
      .btn{
        font-size: 20px;
        line-height: 35px;
        padding-right: 15px;
      }
    }
    .supply-btn{
      margin-top: 20px;
      margin-left: 20px;
      .el-button {
        background-color: orange;
        border-radius: 0;
      }
    }
  }

  .nav{
    background: #fff;
    width: 100%;
    height: 49x;
    float: left;
    padding-top: 12px;
    padding-left: 13%;
    padding-right: 13%;
    margin-top: 2px;
    box-sizing: border-box;
    ul{
      width: 90%;
      margin-left: 8%;
      margin-right: 8%;
      display: flex;
      justify-content: space-between;
    }
    li{
      font-size: 16px;
      font-weight: bold;
      line-height: 21px;
      padding-bottom: 12px;
      color: #333;
      cursor: pointer;
      border-bottom: 3px solid #fff;
      &.selected,&:hover{
        color: #39bf3e;
        border-color: #39bf3e;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/homHeader.vue